import React, { FC, Fragment } from 'react';
import { Card, makeStyles } from '@material-ui/core';

import { Network } from 'api/public';
import PublicShareTextBoxV2 from './PublicShareTextBoxV2';
import { Capability } from 'components';

const useStyles = makeStyles(theme => ({
  card: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
    },
  },
}));

const PublicShareCard: FC = () => {
  const classes = useStyles();

  return (
    <Fragment>
      <Capability name="Sharing.Function.ShareToTwitter">
        <Card className={classes.card}>
          <PublicShareTextBoxV2 network={Network.Twitter} />
        </Card>
      </Capability>

      <Capability name="Sharing.Function.ShareToLinkedIn">
        <Card className={classes.card}>
          <PublicShareTextBoxV2 network={Network.Linkedin} />
        </Card>
      </Capability>

      <Capability name="Sharing.Function.ShareToFacebook">
        <Card className={classes.card}>
          <PublicShareTextBoxV2 network={Network.Facebook} />
        </Card>
      </Capability>
    </Fragment>
  );
};

export default PublicShareCard;
